<template>
  <div style="margin-left: 20">
    <div class="container">
      <div class="row">
        <table>
          <tr>
            <td>
            <h3 style="margin-top:10;margin-left: 50;">Feedback Status</h3>
            </td>
          </tr>
        </table>
      </div>
      
      <div class="row">
        <table class="table-horizontal" width="30%" height="20">
          <tbody>
            <tr>
              <td><strong>Status</strong></td>
              <td style="padding-bottom: 6px;">
                <span>
                  <select  class="mumbai" v-model="status" @change="downloadData" >
                    <option v-for="status in statuses" v-bind:key="status.id"  v-bind:id="status" >{{status}}</option>
                  </select>	
                </span>
              
              </td>
            </tr> 
            
            
          </tbody>
        </table>
      </div>
      
      <div class="row" style="margin-top: 15px;" v-if=" result.length >0">
        <table class ="table" >
          <thead class="thead-light"   v-if="status !=='Pending'">
            <tr >
              <th scope="col">Deal Name</th>
              <th scope="col">Feedback Request Date</th>
              <th scope="col">Status</th>
              <th scope="col">Timeliness</th>
              <th scope="col">Overall Feedback</th>
            </tr>
          </thead>
          <tbody v-if="status !=='Pending'">
            <tr  v-for="obj in result" :key="obj.id">
                    <td style="width: 16.66%" ><a :href="obj.link.href" >
                    <span  data-bs-toggle="tooltip" data-bs-placement="bottom" :title=obj.companyName>
  {{obj.companyName}}
</span></a> </td>
                    <td style="width: 20%">{{obj.feedDate}} </td>
                    <td style="width: 16.66%" v-if="obj.status !=='Pending'">{{obj.status}} </td>
                    <td style="width: 16.66%" v-if="obj.status =='Pending'"><span  data-bs-toggle="tooltip" data-bs-placement="bottom" title="Request will expire in 31 days from the feedback request date.">
  {{obj.status}}
</span> </td>

                    <td style="width: 16.66%">{{obj.timeliNess}} </td>
                    <td style="width: 16.66%">{{obj.overAllFeed}} </td>
                </tr>
          </tbody>
          
          <thead class="thead-light" v-if="status ==='Pending' && result.length >0">
            <tr>
              <th scope="col">Deal Name</th>
              <th scope="col">Feedback Request Date</th>
              <th scope="col">Status</th>
            </tr>
          </thead>
          <tbody v-if="status ==='Pending'">
            <tr  v-for="obj in result" :key="obj.id">
                    <td style="width: 16.66%"><a :href="obj.link.href" ><span  data-bs-toggle="tooltip" data-bs-placement="bottom" :title=obj.companyName>
  {{obj.companyName}}
</span></a> </td>
                    <td style="width: 16.66%">{{obj.feedDate}} </td>
                    <td style="width: 16.66%" ><span  data-bs-toggle="tooltip" data-bs-placement="bottom" title="Request will expire in 31 days from the feedback request date.">
  {{obj.status}}
</span> </td>
                    
                </tr>
          </tbody>
        </table>
      </div>
      <div v-if="result.length === 0" class="row alert alert-danger" role="alert">
        No Record Found
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import store from '@/store';
import moment from 'moment';

export default {
  data() {
    return {
      chartOptions: {},
      statuses : ['All','Completed','Pending'],
      status : 'All',
      responseData : {},
      convertedObj : {},
      options : {},
      result : [],
      dealName : '',
      usAnalyst : '',
      mumbaiAnalyst : '',
      feedDate : '',
      groupName : '',
      functionSupported : '',
      tasksPerformed : '',
      feedDateUs : '',
      comment : ''
    };
  },
  computed: {
    user: function() {return store.methods.getUser()}
  },
  async created(){
  this.downloadData();
  },
  methods: {
  getDataPromise () {
    let dashboardUri;

    dashboardUri = process.env.VUE_APP_BACKEND_API+"feedbackStatus?"
    +"user="+this.user
    

     return new Promise(function (resolve, reject) {
        axios.get(dashboardUri).then(
            (response) => {
                var result = response.data;
                console.log('Processing Request');
                resolve(result);
            },
                (error) => {
                reject(error);
            }
        );
    });
     
  },
  linkMaker(result) {
    let getUrl=new URL(process.env.VUE_APP_UI+"usfeedbackform");
    getUrl.searchParams.append('feeddate', result.feedDate);
    getUrl.searchParams.append('grpname', result.grp_name);
    getUrl.searchParams.append('companyname', result.companyName);
    getUrl.searchParams.append('functionsupported', result.function_supported);
    getUrl.searchParams.append('tasksperformed', result.tasks_performed);
    getUrl.searchParams.append('usanalystid', result.us_analyst_id);
    getUrl.searchParams.append('mumbaianalystid', result.mumbai_analyst_id);
    getUrl.searchParams.append('comment', '');
    
    return getUrl;

  },
  dateDiff(dateUs) {
  var given = moment(dateUs, "YYYY-MM-DD");
  var current = moment().startOf('day');

  //Difference in number of days
  // alert(current.diff(given, 'days'))
  return current.diff(given, 'days');
  },
    async downloadData()
  {
    this.responseData = await  this.getDataPromise();
    if(this.responseData) {
      this.responseData.map((currentValue)=>{
              if(!currentValue.anyOtherComment) {
                currentValue.anyOtherComment = '-'
              }
              if(!currentValue.timeliNess) {
                currentValue.timeliNess = '-'
              }
              if(!currentValue.overAllFeed) {
                currentValue.overAllFeed = '-'
              }
              return currentValue
            }) 
      if(this.status ==='All' ) {
        this.result.length = 0;
        let Pending = this.responseData.filter((currentValue) => {
        
          return currentValue.status === 'Pending';
        })
        
        let Completed =this.responseData.filter((currentValue) => {
          return currentValue.status === 'Completed';
        })
        .filter((currentValue) => {
          return this.dateDiff(currentValue.feed_date_us) < 5;
        })
        this.result =[...Pending,...Completed] ;
        this.result.sort((a, b) => new Date(b.feedDate) - new Date(a.feedDate))
        
      } else if(this.status ==='Pending') {
        this.result.length = 0;
        this.result = this.responseData.filter((currentValue) => {
        
          return currentValue.status === 'Pending';
        })
      } else if(this.status ==='Completed') {
        this.result.length = 0;
        this.result = this.responseData.filter((currentValue) => {
          return currentValue.status === 'Completed';
        })
        .filter((currentValue) => {
        // alert(currentValue.feed_date_us)
          return this.dateDiff(currentValue.feed_date_us) < 5;
        })
      }
      for(let r of this.result) {
          r['link'] = this.linkMaker(r)
        }
    } else {
                  alert("No Data found !!!");
              }
  }
  }
};
</script>
<style scoped>

#container {
  height: 400px;
}

.grayout {
    opacity: 0.6; /* Real browsers */
    filter: alpha(opacity = 60); /* MSIE */
}
.mumbai{
width: 160px;
margin-top:10px;
height: 25px;
}


table.table tr > td
{
 max-width: 100px ;
 overflow: hidden;
 text-overflow: ellipsis;
 white-space: nowrap;
}

thead th {
  
  padding-top: 0.5px !important;
  padding-bottom: 5.5px !important;
  height: 35px !important;
}


</style>